import { Client, Order } from "@/types"
import { MapRoute } from "@/views/MapView"

import { AboutClient } from "./AboutClient"
import { AboutOrder } from "./AboutOrder"

type AboutProps = {
  id: Order["id"] | Client["id"]
  type: "order" | "client"
  close: () => void
  setRoutes: (routes: MapRoute[]) => void
}

export const About = ({ id, type, close, setRoutes }: AboutProps) => {
  if (type === "order") {
    return <AboutOrder id={id} close={close} setRoutes={setRoutes} />
  }

  if (type === "client") {
    return <AboutClient id={id} close={close} />
  }

  return null
}
